function Home(){
    return(
        <div className="hero">
            <h1>Hello World!</h1>
            <h3>I'm Choyrul Annam</h3>
            <span>A passionate software developer</span>
        </div>  
    );
}

export default Home;